import { Injectable, isDevMode } from '@angular/core';
import { Subject } from 'rxjs';
import { UserStorageService } from '../../user-storage-service/user-storage.service';
import { tap } from 'rxjs/internal/operators/tap';
import { map } from 'rxjs/internal/operators/map';
import { PreparationBasic } from 'src/app/models/catalogs-model/preparation.model';
import { PreparationsDaoService } from 'src/app/dao/catalogs-dao-services/preparations-dao-services/preparations-dao.service';
@Injectable({
  providedIn: 'root'
})
export class PreparationsService {

  refreshPreparationsListener = new Subject<any>();
  refreshPreparationListener = new Subject<any>();
  filterPreparationsListener = new Subject<any>();
  searchPreparationsListener = new Subject<any>();
  togglePreparationsDispositionListener = new Subject<any>();

  constructor(private userStorageService: UserStorageService,
              private preparationsDaoService: PreparationsDaoService) { }

  public getPreparationsCounts() {
    return this.preparationsDaoService.getPreparationsCounts(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => {
        if (o) {
          return {
            availablePreparations: o['data']['preparations']['nbAvailables'],
            unavailablePreparations: o['data']['preparations']['nbDisabled']
          };
        }
      })
    );
  }

  public getPreparationsList() {
    return this.preparationsDaoService.getPreparationsList(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => {
        if (o) {
          const preparations = new Array<PreparationBasic>();
          o['data']['preparations'].forEach(
            (preparation) => {
              preparations.push(Object.assign(new PreparationBasic(), preparation));
            }
          );
          return preparations;
        }
      })
    );
  }

  public getPreparationInfo(internalId) {
    return this.preparationsDaoService.getPreparationInfo(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => {
        if (o) {
          const preparation = new PreparationBasic();
          Object.assign(preparation, o['data']['preparation']);
          return preparation;
        }
      })
    );
  }

  public addNewPreparation(imageUrl, preparationForm) {
    return this.preparationsDaoService.addNewPreparation(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), imageUrl, preparationForm.get('active').value, preparationForm.get('name').value, preparationForm.get('code').value).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => o)
    );
  }

  public updatePreparationStatus(internalId, active) {
    return this.preparationsDaoService.updatePreparationStatus(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId, active).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => o['data'])
    );
  }

  public updatePreparationInfo(internalId, preparationForm) {
    return this.preparationsDaoService.updatePreparationInfo(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId, preparationForm.get('active').value, preparationForm.get('name').value, preparationForm.get('code').value).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => o)
    );
  }

  public updatePreparationImage(internalId, imageUrl) {
    return this.preparationsDaoService.updatePreparationImage(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId, imageUrl).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => o)
    );
  }

  public deletePreparation(internalIds) {
    return this.preparationsDaoService.deletePreparation(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalIds).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => o['data'])
    );
  }

  public refreshPreparations() {
    this.refreshPreparationsListener.next();
  }

  public refreshPreparationsListen() {
    return this.refreshPreparationsListener.asObservable();
  }

  public refreshPreparation() {
    this.refreshPreparationListener.next();
  }

  public refreshPreparationListen() {
    return this.refreshPreparationListener.asObservable();
  }

  public filterPreparations(opts) {
    this.filterPreparationsListener.next(opts);
  }

  public filterPreparationsListen() {
    return this.filterPreparationsListener.asObservable();
  }

  public searchPreparations(key) {
    this.searchPreparationsListener.next(key);
  }

  public searchPreparationsListen() {
    return this.searchPreparationsListener.asObservable();
  }

  public togglePreparationsDisposition(viewDis) {
    this.togglePreparationsDispositionListener.next(viewDis);
  }

  public togglePreparationsDispositionListen() {
    return this.togglePreparationsDispositionListener.asObservable();
  }
}
